import type {
  AliasHighlight,
  DocumentSubject,
} from 'features/knowledgeDocumentViewer/types/documentSubjects'

/**
 * Flatten subjects → aliases → boxes into drawable highlights, converting the
 * API's `[x0, y0, x1, y1]` into the viewer's left/top/width/height form.
 * References persisted without coordinates arrive as `bbox: null` and are
 * skipped — they ground the subject on the document but aren't drawable.
 */
export function flattenAliasHighlights(
  subjects: DocumentSubject[]
): AliasHighlight[] {
  const highlights: AliasHighlight[] = []
  for (const subject of subjects) {
    for (const alias of subject.aliases) {
      for (const box of alias.boxes) {
        if (!box.bbox) continue
        const [x0, y0, x1, y1] = box.bbox
        highlights.push({
          page: box.page,
          bbox: {
            left: x0,
            top: y0,
            width: x1 - x0,
            height: y1 - y0,
          },
          subjectUid: subject.subject_uid,
          aliasNorm: alias.norm,
          label: alias.value,
        })
      }
    }
  }
  return highlights
}
